const kvValueType = {
  CONDITIONAL: 'conditional',
  DATETIME: 'date time',
  NUMERIC: 'numeric',
  UNKNOWN: 'unknown',
  DATAFILE: 'data file',
  TEXT: 'text',
}

const kvValuePeripheralKeys = {
  UNITS: 'Units',
  SIGFIG: 'SignificantFigures',
}

function isNumericType(valueType) {
  return (valueType == kvValueType.NUMERIC)
}

function calculateDisplayValue(kvValue) {
  if (!(kvValue && kvValue.Value != null)) {
    return null
  }
  let significantFigures = kvValue.PeripheralData && kvValue.PeripheralData[kvValuePeripheralKeys.SIGFIG]
  if (!(significantFigures && Number.isInteger(significantFigures) && typeof(kvValue.Value) == 'number')) {
    return kvValue.Value
  }
  return kvValue.Value.toPrecision(significantFigures)
}

function calculateAggregateDisplayValue(kvValue, aggregateType) {
  if (!(kvValue && kvValue.AggregateValues && kvValue.AggregateValues[aggregateType] != null)) {
    return null
  }
  let value = kvValue.AggregateValues[aggregateType]
  let significantFigures = kvValue.PeripheralData && kvValue.PeripheralData[kvValuePeripheralKeys.SIGFIG]
  if (!(significantFigures && Number.isInteger(significantFigures) && typeof(value) == 'number')) {
    return value
  }
  return value.toPrecision(significantFigures)
}

export {
  isNumericType,
  kvValuePeripheralKeys,
  kvValueType,
  calculateDisplayValue,
  calculateAggregateDisplayValue,
}